import KEY_CODES from '../../../../../shared/utils/keyCodes'

export const getCursorPosition = textDom => {
  let cursorPos = 0
  if (textDom.setSelectionRange) {
    textDom.focus()
    cursorPos = textDom.selectionStart
  }
  return cursorPos
}

export const setCursorPosition = (textDom, pos) => {
  if (textDom.setSelectionRange) {
    textDom.focus()
    textDom.setSelectionRange(pos, pos)
  }
}

const handleKeyUp = e => {
  const { target } = e
  const elem = target
  // for some andriod system keyboard can not input (eg: vivo)
  setTimeout(() => {
    const str = elem.value
    const currentPos = getCursorPosition(elem)
    let posAfterText = ''
    let posPreText = ''
    let isNextBlank = false// the next is blank or not
    let isPreBlank = false
    let isLastPos = true
    if (currentPos !== str.length) { // not the last one
      posAfterText = str.substr(currentPos, 1)
      posPreText = str.substr(currentPos - 1, 1)
      isNextBlank = /^\s+$/.test(posAfterText)
      isPreBlank = /^\s+$/.test(posPreText)
      isLastPos = false
    }
    if (e.keyCode === KEY_CODES.BACKSPACE) { // delete key
      if (isPreBlank) {
        setCursorPosition(elem, currentPos - 1)
      } else {
        setCursorPosition(elem, currentPos)
      }
    } else if (!isLastPos) {
      if (isNextBlank) {
        setCursorPosition(elem, currentPos + 1)
      } else {
        setCursorPosition(elem, currentPos)
      }
    } else {
      setCursorPosition(elem, elem.value.length)
    }
  }, 0)
}

export default handleKeyUp
